import React from 'react';
import { Avatar } from 'antd';
import {
  AIHistoryPageIcon,
  FlyIcon,
  GearIcon,
  HomeIcon,
  InventoryPageColorIcon,
  ListMenuIcon,
  LogiblocksIcon,
  VideoSquareIcon,
} from '@/assets/icons/icons';
import {
  AiHistoryIcon,
  DashboardIcon1 as DashboardIcon,
  ChatIcon,
  FlyingIcon,
  InventoryIcon,
  SettingsIcon,
  ShipmentIcon,
} from '@/assets/images';
import theme from '@/assets/theme';

export type IconMapValue =
  string | React.ComponentType<unknown> | React.ReactElement;

const LanePlannerGlobeIcon: React.FC<{ color?: string; size?: number }> = ({
  color = 'white',
  size = 20,
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
  >
    <circle cx='12' cy='12' r='9' stroke={color} strokeWidth='1.5' />
    <path
      d='M3 12h18M12 3c2.5 2.8 3.8 5.8 3.8 9s-1.3 6.2-3.8 9c-2.5-2.8-3.8-5.8-3.8-9s1.3-6.2 3.8-9z'
      stroke={color}
      strokeWidth='1.5'
    />
  </svg>
);

export const createMobileMenuIconMap = (): Record<string, IconMapValue> => ({
  DashboardIcon,
  SettingsIcon,
  ShipmentIcon,
  FlyingIcon,
  AiHistoryIcon,
  InventoryIcon,

  ColoredDashboardIcon: HomeIcon,
  ColoredSettingsIcon: GearIcon,
  ColoredFlyingIcon: FlyIcon,
  ColoredShipmentIcon: VideoSquareIcon,
  ColoredAIHistoryIcon: AIHistoryPageIcon,
  ColoredInventoryIcon: InventoryPageColorIcon,

  ChatIcon: <ChatIcon fillcolor='#3D81FF' />,
  ColoredChatIcon: <ChatIcon color={theme.primary} fillcolor='white' />,

  LogiBlocksIcon: <LogiblocksIcon color='white' size={20} />,
  ColoredLogiBlocksIcon: <LogiblocksIcon color={theme.primary} size={20} />,

  DataIcon: <ListMenuIcon fill='white' size={20} />,
  ColoredDataIcon: <ListMenuIcon fill={theme.primary} size={20} />,

  LanePlannerIcon: <LanePlannerGlobeIcon color='white' />,
  ColoredLanePlannerIcon: (
    <LanePlannerGlobeIcon color={theme.primary || theme.activeIcon} />
  ),
});

export function renderMobileMenuIcon(icon: IconMapValue): React.ReactNode {
  if (typeof icon === 'string') {
    return <Avatar size={22} src={icon} />;
  }

  if (typeof icon === 'function') {
    const activeColor = theme.activeIcon || theme.primary;
    const IconComponent = icon as React.ComponentType<{
      color?: string;
      fill?: string;
      size?: number;
    }>;
    return <IconComponent color={activeColor} fill={activeColor} size={20} />;
  }

  if (React.isValidElement(icon)) {
    return icon;
  }

  return null;
}
